export const DELIVERY_METHODS = {
    ADD_TO_CART: 'Add to cart',
    ADDED_TO_CART: 'Added to cart',
    WEB_INVENTORY: 'webInventory',
    SHIP_TO_ME_ABBREVIATION_VAL: 'stm',
};
